import { useTitle } from 'react-use';

import { Layout } from 'CorePackage/MainModule/components/Layout';

import { Import } from '../components/Import';

export const ImportPage = () => {
  useTitle('Импорт данных');

  return (
    <Layout withFooter>
      <Import />
    </Layout>
  );
};
